export default __webpack_public_path__ + "static/media/badcrewkor.a2aac65a.png";